<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>入学年转化报表</span>
          </div>
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
              prop="date"
              label="年份"
              width="100"
              :header-cell-style="{background:'#000000'}">
            </el-table-column>
            <el-table-column
              prop="0"
              label="日本">
            </el-table-column>
            <el-table-column
              prop="1"
              label="美国">
            </el-table-column>
            <el-table-column
              prop="2"
              label="英国">
            </el-table-column>
            <el-table-column
              prop="3"
              label="澳洲">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      tableData: []
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
  },
  created() {
    this.$http._post({
      url: '/index/b_i_teacher/yearReport',
    }).then(({ data }) => {
      this.tableData = data;
    });
  },
};
</script>

<style type="text/css">
  .el-table th {
    background-color: #01142d;
    color: #fff;
  }
</style>
